// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_ALONE = "Na fotoportr\u00e9tu m\u00e1 b\u00fdt pouze tvoje tv\u00e1\u0159.";
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_VISIBLE_FACE = "Na fotoportr\u00e9tu m\u00e1 b\u00fdt jasn\u011b vid\u011bt tvoje tv\u00e1\u0159.";
export const COMPLAINT_USERS_PROFILE_AVATAR_NOT_YOU = "Na fotoportr\u00e9tu m\u00e1 b\u00fdt tvoje skute\u010dn\u00e1 tv\u00e1\u0159.";
export const SINCE = "od";
export const THE_AVATAR_HAS_BEEN_BLOCKED_BY_ADMINS_IT_BREACHES_THE_RULES = "Profilovou fotku vid\u00ed\u0161 jen ty.";
